import React from "react";

import { useIntl } from "react-intl";

import { Alert, Button } from "@mapmycustomers/ui";

import styles from "./AddressChangeAlert.module.scss";
import messages from "./messages";

interface Props {
  addressChanged: boolean;
  handleUndo: () => void;
}

const AddressChangeAlert: React.FC<Props> = ({ addressChanged, handleUndo }) => {
  const intl = useIntl();
  return (
    <Alert
      action={
        addressChanged && (
          <Button onClick={handleUndo} size="large" type="link">
            {intl.formatMessage(messages.undo)}
          </Button>
        )
      }
      className={styles.changeAlert}
      closable={!addressChanged}
      message={intl.formatMessage(
        addressChanged ? messages.addressChanged : messages.coordinatesChanged
      )}
      showIcon
      type={addressChanged ? "warning" : "info"}
    />
  );
};

export default AddressChangeAlert;
